import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { resolveLanguage } from '../i18n/config'

/**
 * 문서 수준 언어 표시를 현재 화면 언어와 맞춘다.
 *
 * `<html lang>` 은 접근성·브라우저 번역 판단에,
 * title·description 은 검색 결과와 공유 미리보기에 쓰인다.
 * 기존에는 빌드 시점의 영어 값으로 고정돼 한국어 화면과 어긋났다.
 */
export function useDocumentLanguage(): void {
  const { t, i18n } = useTranslation()
  const language = resolveLanguage(i18n.language)

  useEffect(() => {
    document.documentElement.lang = language
    document.title = t('meta.title')

    let meta = document.querySelector('meta[name="description"]')
    if (!meta) {
      meta = document.createElement('meta')
      meta.setAttribute('name', 'description')
      document.head.appendChild(meta)
    }
    meta.setAttribute('content', t('meta.description'))
  }, [language, t])
}

export default useDocumentLanguage
